import {FormikConfig} from 'formik';

import utils from '@utils';

export const main: Pick<FormikConfig<any>, 'validate'>['validate'] = (
  values: any
) => {
  const errors: any = {};

  utils.validate.email(errors, values);
  utils.validate.password(errors, values, {
    key: 'password',
    require: true,
    label: 'パスワード',
  });

  return errors;
};
